<script>
import { mapActions } from 'vuex';

export default {
  props: {
    newRulesCollection: {
      type: Array,
      default: null,
    },
  },
  watch: {
    newRulesCollection(value) {
      if (value) {
        this.saveRules();
      }
    },
  },
  methods: {
    ...mapActions({
      updateConfigRules: 'updateConfigRules',
      saveRules: 'saveRules',
    }),
    onClose() {
      this.$emit('on-close');
    },
    saveRules() {
      this.updateConfigRules({ rules: this.newRulesCollection }).then(
        () => {
          this.$emit('on-saved');
          this.showMessage({
            title: 'Success',
            text: 'Fraud rules updated',
          });
        },
        (error) => {
          this.showMessage({
            title: 'Something went wrong saving your config',
            text: error?.response?.data?.message,
            isError: true,
          });
        },
      );
    },
    showMessage(options = {}) {
      this.$notify({
        group: 'api',
        type: options.isError ? 'error' : 'success',
        title: options.title,
        duration: options.duration || 5000,
        text: options.text || '',
      });
    },
  },
};
</script>

<template>
  <div class="rule-save"></div>
</template>
